var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileageOdometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.944 18.615a.559.559 0 01-.5-.305 6.59 6.59 0 00-3.91-3.292 7.488 7.488 0 00-1.048-.237l-.072-.01 3.729-11.66.063.003c7.244 1.968 11.39 7.774 12.487 9.507a.558.558 0 01-.224.8l-10.273 5.135a.561.561 0 01-.252.06z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.686 20.833a.997.997 0 100-1.994.997.997 0 000 1.994z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.995 18.6a.56.56 0 01-.261-.065L.52 13.147a.56.56 0 01-.217-.788 22.64 22.64 0 015.108-5.73c3.528-2.796 7.54-4.198 11.925-4.175 1.645.008 3.281.23 4.868.66l.063.017-3.73 11.658-.052-.008a8.323 8.323 0 00-1.014-.09c-3.795-.107-5.44 2.477-5.971 3.593a.55.55 0 01-.505.317z",
    fill: "#E95832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.19 3.174l-2.638 11.785a7.51 7.51 0 00-1.057-.24l3.693-11.545h.001z",
    fill: "#282828"
  })));
}
export default __webpack_public_path__ + "static/media/mileage-odometer.a8f553fb.svg";
export { SvgMileageOdometer as ReactComponent };